<py-modal
  [title]="'product.inquiry.modal.page_title' | cxTranslate"
  [showCancelButton]="true"
  [cancelButtonText]="'common.cancel_action' | cxTranslate"
  [actions]="templateActions"
  [scrollable]="true"
  [centered]="true"
  [cxFocus]="focusConfig"
  (esc)="closeModal('escape pressed')"
>
  <div class="row">
    <div class="col">
      <p class="mb-7">
        {{ 'product.inquiry.modal.page_text' | cxTranslate }}
      </p>

      <form [formGroup]="form">
        <py-reactive-form-input-field
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'firstName'"
          [label]="'product.inquiry.modal.firstName_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.firstName_placeholder' | cxTranslate"
        ></py-reactive-form-input-field>

        <py-reactive-form-input-field
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'lastName'"
          [label]="'product.inquiry.modal.lastName_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.lastName_placeholder' | cxTranslate"
        ></py-reactive-form-input-field>

        <py-reactive-form-input-field
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'email'"
          [label]="'product.inquiry.modal.email_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.email_placeholder' | cxTranslate"
          [inputType]="'email'"
        ></py-reactive-form-input-field>

        <ng-container *ngIf="phoneCodes$ | async as phoneCodes">
          <div class="d-none mb-7" [class.d-block]="phoneCodes?.length > 1">
            <label class="input-label-content">{{ 'product.inquiry.modal.phonePrefix_heading' | cxTranslate }}</label>

            <py-dropdown [formControlName]="'countryPhoneCode'" [options]="phoneCodes"></py-dropdown>
          </div>
        </ng-container>

        <py-reactive-form-input-field
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'phone'"
          [label]="'product.inquiry.modal.phoneNumber_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.phoneNumber_placeholder' | cxTranslate"
        ></py-reactive-form-input-field>

        <py-reactive-form-input-field
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'companyName'"
          [label]="'product.inquiry.modal.companyName_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.companyName_placeholder' | cxTranslate"
        ></py-reactive-form-input-field>

        <div class="mb-7">
          <label class="d-block input-label-content">{{ 'product.inquiry.modal.howToBeContacted_hint' | cxTranslate }}</label>

          <div class="d-flex my-2">
            <div class="radio-option-label d-inline-flex">
              <py-radio [showLabel]="true">
                <input formControlName="contactType" type="radio" [value]="pdpInquiryContactTypes.EMAIL" />
                <span class="radio-title" slot="label">{{ 'product.inquiry.modal.emailRadioOption_heading' | cxTranslate }}</span>
              </py-radio>
            </div>

            <div class="radio-option-label d-inline-flex">
              <py-radio [showLabel]="true">
                <input formControlName="contactType" type="radio" [value]="pdpInquiryContactTypes.PHONE" />
                <span class="radio-title" slot="label">{{ 'product.inquiry.modal.PhoneRadioOption_heading' | cxTranslate }}</span>
              </py-radio>
            </div>
          </div>
        </div>

        <div [class.d-none]="contactTypeFormControl.value === pdpInquiryContactTypes.EMAIL">
          <div class="mb-7">
            <div class="d-flex align-items-center mb-2">
              <label class="input-label-content d-block">{{ 'product.inquiry.modal.date_heading' | cxTranslate }}</label>

              <i
                class="tooltip-icon ml-2"
                nz-icon
                nzType="question-circle"
                [ngbTooltip]="'product.inquiry.modal.date_tooltip' | cxTranslate"
              ></i>
            </div>

            <py-reactive-form-checkbox-slider
              class="d-block mb-3"
              [group]="form"
              [fieldName]="'anyContactDate'"
              [rightLabel]="'product.inquiry.modal.anyDate_heading' | cxTranslate"
              [addMargin]="false"
            ></py-reactive-form-checkbox-slider>

            <py-date-picker
              class="w-100"
              [id]="'pdp-phone-contact-date-calendar'"
              [formControlName]="'contactDate'"
              [min]="getMinPhoneContactDate()"
              [disabledDays]="[0, 6]"
              [placement]="'right'"
              (formattedValueChange)="phoneContactFormattedDate = $event"
            ></py-date-picker>

            <div class="invalid-feedback">{{ contactDateFormControl.errors | inputError }}</div>
          </div>

          <div class="mb-7">
            <div class="d-flex align-items-center mb-2">
              <label class="input-label-content d-block">{{ 'product.inquiry.modal.time_heading' | cxTranslate }}</label>

              <i
                class="tooltip-icon ml-2"
                nz-icon
                nzType="question-circle"
                [ngbTooltip]="'product.inquiry.modal.time_tooltip' | cxTranslate"
              ></i>
            </div>

            <py-reactive-form-checkbox-slider
              class="d-block mb-3"
              [group]="form"
              [fieldName]="'anyContactTimeSlot'"
              [rightLabel]="'product.inquiry.modal.anyTime_heading' | cxTranslate"
              [addMargin]="false"
            ></py-reactive-form-checkbox-slider>

            <div formArrayName="contactTimeSlots" class="contact-timeslots-wrapper d-sm-flex flex-wrap">
              <div *ngFor="let timeSlot of timeSlots$ | async; let i = index" class="mb-3">
                <py-reactive-form-checkbox
                  [group]="contactTimeSlotsFormArray"
                  [rounded]="true"
                  [fieldName]="i.toString()"
                  [rightLabel]="'product.inquiryFormTimeSlot' | cxTranslate: { context: timeSlot.toLowerCase() + '_heading' }"
                ></py-reactive-form-checkbox>
              </div>
            </div>

            <div *ngIf="contactTimeSlotsFormArrayInvalid" class="invalid-feedback d-block">
              {{ contactTimeSlotsFormArray.errors | inputError }}
            </div>
          </div>
        </div>

        <ng-container *ngIf="!!modelOptions">
          <div class="d-block mb-7">
            <div class="d-flex align-items-center mb-2">
              <label class="input-label-content">{{ 'product.inquiry.modal.model_heading' | cxTranslate }}</label>

              <i
                class="tooltip-icon ml-2"
                nz-icon
                nzType="question-circle"
                [ngbTooltip]="'product.inquiry.modal.model_tooltip' | cxTranslate"
              ></i>
            </div>

            <py-dropdown
              [formControlName]="'model'"
              [options]="modelOptions"
              [title]="'product.inquiry.modal.model_placeholder' | cxTranslate"
            ></py-dropdown>

            <div
              *ngIf="(this.modelFormControl.dirty || this.modelFormControl.touched) && modelFormControl.invalid"
              class="invalid-feedback d-block mt-2"
            >
              {{ modelFormControl.errors | inputError }}
            </div>
          </div>
        </ng-container>

        <py-reactive-form-textarea
          class="d-block mb-7"
          [group]="form"
          [fieldName]="'additionalInfo'"
          [label]="'product.inquiry.modal.additionalInfo_heading' | cxTranslate"
          [placeholder]="'product.inquiry.modal.additionalInfo_placeholder' | cxTranslate"
          [optional]="true"
          [maxLength]="300"
        ></py-reactive-form-textarea>
      </form>
    </div>
  </div>
</py-modal>

<ng-template #templateActions>
  <py-action-button
    [buttonClass]="'w-100 btn btn-primary'"
    [buttonLabel]="'product.inquiry.modal.submit_action' | cxTranslate"
    [disabled]="form.invalid && formSubmitted"
    [success]="sendInquirySuccess$ | async"
    [loading]="sendInquiryLoading$ | async"
    (activate)="onFormSubmit()"
  >
  </py-action-button>
</ng-template>
